import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_social-x",
  "use": "icon_social-x-usage",
  "viewBox": "0 0 21 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 17\" id=\"icon_social-x\"><path d=\"M2.094 1l6.88 8.97-6.924 7.295h1.558l6.061-6.386 4.897 6.386h5.302l-7.266-9.476L19.046 1h-1.558l-5.582 5.881L7.396 1H2.094zm2.291 1.12H6.82l10.756 14.025H15.14L4.385 2.12z\" fill=\"currentColor\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol